import { useQuery } from 'react-query';

import { estimateBatchReprocess, ReprocessEstimate, ReprocessPayload } from 'src/api/functions/assetsApi';
import { useAccessToken } from 'src/hooks/useAccessToken';

/**
 * Prices a reprocess batch (saas#1262). Side-effect free on the server, so it
 * is safe to refetch whenever the ids or outputs change.
 */
export const useReprocessEstimate = (payload: ReprocessPayload, enabled: boolean) => {
  const accessToken = useAccessToken();
  return useQuery<ReprocessEstimate, any>(
    ['reprocess-estimate', payload],
    () => estimateBatchReprocess(payload, accessToken),
    { enabled: enabled && payload.ids.length > 0, retry: false, staleTime: 30_000 },
  );
};

export default useReprocessEstimate;
